import { Formik } from 'formik';
import type { ReactNode } from 'react';
import type { Warranty } from '@econtractor/types';
import { emptyWarranty, type WarrantyFormValues } from './model/warrantyDates';

interface WarrantyFormikProps {
    initial: Warranty | null;
    save: (values: WarrantyFormValues) => Promise<number | false>;
    children: ReactNode;
}

const WarrantyFormik = ({ initial, save, children }: WarrantyFormikProps) => (
    <Formik
        initialValues={
            initial
                ? {
                      productId: initial.productId,
                      serialNumber: initial.serialNumber,
                      serialNumbers: [initial.serialNumber || ''],
                      purchasedAt: initial.purchasedAt,
                      warrantyUntil: initial.warrantyUntil,
                      objectId: initial.objectId,
                      actualVendorId: initial.actualVendorId ?? null,
                  }
                : emptyWarranty()
        }
        enableReinitialize
        onSubmit={async (values) => {
            await save(values);
        }}
    >
        {children}
    </Formik>
);

export default WarrantyFormik;
